import React, {useContext} from 'react'

export type Bag<T = any> = {
  items: T[]
  includes: (item: T) => boolean
  add: (item: T) => void
  remove: (item: T) => void
  clear: () => void
}

const BagContext = React.createContext<Bag>(null as any)

export default BagContext

export function useBagContext() {
  return useContext(BagContext)
}
